import { gql } from '@apollo/client';
import Fragments from './components/fragments';

export const ITEM_GENERAL_DATA_QUERY = gql`
  query itemGeneralData($id: Int!) {
    itemGeneralData(id: $id) {
      id
      code
      name
      shortName
      typeId
      typeCode
      typeName
      enabled
      description
    }
  }
`;

export const ITEM_PROPERTIES_QUERY = gql`
  query itemProperties($id: Int!) {
    itemProperties(id: $id) {
      ...itemProperty
    }
  }
  ${Fragments.itemProperty}
`;

export const PROPERTY_VALUE_TYPES_QUERY = gql`
  query propertyValueTypes {
    propertyValueTypes {
      id
      code
      name
      isActive
    }
  }
`;

export const PROPERTY_VALUES_QUERY = gql`
  query propertyValues($itemId: Int!, $propertyId: Int!) {
    propertyValues(itemId: $itemId, propertyId: $propertyId) {
      propertyValueId
      value
      propertyMinValue
      propertyMaxValue
    }
  }
`;

export const PROPERTY_DETAILS = gql`
  query propertyDetails($propertyId: Int!) {
    propertyDetails(propertyId: $propertyId) {
      propertyDetailId
      propertyValue
    }
  }
`;

export const GENERIC_FILTER_TEMPLATE_DETAILS_QUERY = gql`
  query genericFilterTemplateDetails($id: Int!) {
    genericFilterTemplateDetails(id: $id) {
      id
      conditions {
        id
        templateId
        paramId
        operatorId
        value
        valueId
        orderNo
        values {
          id
          detailId
          value
          valueId
        }
      }
    }
  }
`;
